<template>
  <div class="d-flex flex-column align-items-start py-2 px-4">
    <h3 class="font-weight-bold">Recuperar Contraseña</h3>
    <p>Ingresa el correo electrónico asociado a tu cuenta</p>
    <div class="form-group w-100">
      <label for="getEmail" class="float-left">Correo electrónico</label>
      <input
        type="email"
        class="form-control"
        id="getEmail"
        aria-describedby="getEmail"
        placeholder="Ingresa tu email"
        v-model="email"
      >
    </div>
    <router-link to="/correctpass" class="btn btn-primary mt-4 btn-lg btn-block">Continuar</router-link>
  </div>
</template>

<script>
export default {
  name: 'NewPassword',
  data() {
    return {
      email: ''
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// NewPassword.vue?6e39d12f